module.exports = __webpack_public_path__ + "static/media/Goodnest_ios_3.bb816fdc.jpg";